const __bucketName = 'kv3';
let _zoomLevel = 0;

let _isDemo = null;
let _isShowroomMode = false;
let _isTimeoutDisabled = false;
let _isTabletMode = false;
let _kioskConfigs = {};
let _userInfo = {};
let _kioskStandAlone =  document.kvConfig && document.kvConfig.kioskMode && (
// eslint-disable-next-line no-restricted-globals
  (parent && parent.window && parent.window.app && parent.window.app.db) ||
// eslint-disable-next-line no-restricted-globals
  (parent.parent && parent.parent.window && parent.parent.window.app && parent.parent.window.app.db)
);
// eslint-disable-next-line no-restricted-globals
let _parent = parent || null;
// eslint-disable-next-line no-restricted-globals
if(_kioskStandAlone && parent && parent.parent && parent.parent.window && parent.parent.window.app)
// eslint-disable-next-line no-restricted-globals
  _parent = parent.parent;

try {
  if(parent && parent.exitEditQuote) { //editing from dashboard
    _parent = parent;
  }
} catch (e) {
  //console.log('Error accessing window.parent.property ', e)
  console.log('running in iframe on remote site');
}

export const UseFullSizeImages = window.location.href.indexOf('fsi=') !== -1;

export const IS_OFFLINE_MODE = document.kvConfig.offlineMode || window.location.href.includes("offlineMode");
export const USE_SERVER_CACHING = true;
export const AVAILABLE_VISUALIZERS = {
  Bathroom: "Bathroom",
  Kitchen: "Kitchen",
  Fireplace: "Fireplace",
  LaundryRoom: "LaundryRoom",
};
export const BATHROOM_VISUALIZER_TYPES = ["Bathroom", "BV", "bvScene", "bvLook"];
export const AVAILABLE_VISUALIZER_TYPES = {
  Bathroom: "Bathroom", // toolVersion 4
  Kitchen: "Kitchen", // toolVersion 4
  kvScene: "kvScene", // toolVersion 5
  bvScene: "bvScene", // toolVersion 5
  bvLook: "bvLook", // toolVersion 5
  Fireplace: "Fireplace", // toolVersion 6
  LaundryRoom: "LaundryRoom", // toolVersion 6
};

export const NAVIGATION_TYPES = {
  qkb: "qkb", // regular ui
  look: "look", // lixil 1
  product: "product", // lixil 2
};

export const IS_LIXIL_SERVERS = window.location.host.includes("qkandb")
  || window.location.host.includes("kbquote")
  || window.location.host.includes("grohe")
  || window.location.host.includes("americanstandard-us")
  || (document.kvConfig.domain && document.kvConfig.domain.includes("qkandb.net"))
  || (document.kvConfig.domain && document.kvConfig.domain.includes("kbquote.com"));

export const IS_LIXIL_PRODUCTION = IS_LIXIL_SERVERS && !window.location.host.includes("qkandb");

if (IS_LIXIL_SERVERS && !document.kvConfig.devMode) {
  // document.kvConfig.toolVersion = 6;
  if (document.kvConfig.userId === 140818 && document.kvConfig.visualizerType === "Kitchen") {
    document.kvConfig.toolVersion = 5;
  }
  if (!window.location.href.includes("nav=")) {
    document.kvConfig.navigationType = "look";
  }
}

export const IS_PRODUCT_JOURNEY = document.kvConfig.navigationType === NAVIGATION_TYPES.product || window.location.href.includes("nav=product");
export const IS_LOOK_JOURNEY = document.kvConfig.navigationType === NAVIGATION_TYPES.look || window.location.href.includes("nav=look");
export const IS_LIXIL_UI = IS_PRODUCT_JOURNEY || IS_LOOK_JOURNEY;
export const IS_QKB_UI = document.kvConfig.navigationType === NAVIGATION_TYPES.qkb || !IS_LIXIL_UI;

export const USE_FAB_FILTERS_ONLY = window.location.href.includes("ff=1");

if (IS_PRODUCT_JOURNEY) {
  document.kvConfig.navigationType = NAVIGATION_TYPES.product;
  // document.body.classList.remove('theme-qc');
  document.body.classList.add('bv', 'theme-lixil', 'theme-grohe');
} else if (IS_LOOK_JOURNEY) {
  document.kvConfig.navigationType = NAVIGATION_TYPES.look;
  // document.body.classList.remove('theme-qc');
  document.body.classList.add('bv', 'theme-lixil', 'theme-look');
} else {
  document.kvConfig.navigationType = NAVIGATION_TYPES.qkb;
  document.body.classList.add('bv', 'theme-qc');
}

export const getCommonVisualizerType = (visualizerType) => {
  const stringToCheck = visualizerType || document.kvConfig.visualizerType;
  switch (stringToCheck) {
    case "Bathroom":
    case "BV":
    case "bvScene":
    case "bvLook":
      return "bathroom";
    case "Kitchen":
    case "KV":
    case "kvMaster":
    case "kvScene":
      return "kitchen";
    case "Fireplace":
      return "fireplace";
    case "LaundryRoom":
      return "laundryroom";
    default:
      return (stringToCheck || "").toLowerCase()
  }
}

export const AVAILABLE_LANGUAGES = ["en-US","en-AU","fr-FR","pl-PL","es-ES"];
export const POST_MESSAGES = {
  setIframeLanguage: "SET_IFRAME_LANGUAGE",
  userRegisterTrue: "analytics_register_success",
  userRegisterFalse: "analytics_register_error",
  userLoginTrue: "analytics_login_success",
  userLoginFalse: "analytics_login_error",
};

export const IS_BATHROOM_OLD_BV_SCENE = window.location.href.includes("kitchen8k.quotesflooring")
  || window.location.href.includes("bathroom_8k.quotekandb.com");

export const REACT_APP_GOOGLE_API_KEY = "AIzaSyCU0TUFdkbHi0O4yAUPMPxSC7tzyTy84AY"; // same as the Solar app

// export const USE_LIGHT_QT_CAT_REQUEST = (window.location.href.includes("quotekandb.com") // not used anymore, old logic
//   || (document.kvConfig.domain === "https://quotekandb.com")
//   || IS_LIXIL_SERVERS);


const _isQTEmbedded = window.location.href.indexOf('qt=1') !== -1;
const _isTutorial = window.location.href.indexOf('intro=1') !== -1;
const _visMgmt = window.location.href.indexOf('visMgmt=1') !== -1;
const _isDevMode = (window.location.href.indexOf('dev=1') !== -1) || (document.kvConfig.devMode);
const _showAllVisualizerGroups = (window.location.href.indexOf('all=1') !== -1) || (document.kvConfig.showAllVisualizerGroups);
const _isMobile = (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
  || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4)));

export const IS_AS_BATHROOM = (!window.location.href.includes("grohe")
  && (["dev", "bravo2"].every(subDom => (window.location.host || "").split(".")[0] !== subDom))) || _isDevMode;

let _subdomain = 'demo';

if (_kioskStandAlone) {
  _parent.window.app.db.tables.config.getConfigs((configs) => {
    configs.forEach(c => {
      _kioskConfigs[c.key] = c.value;
    });
    console.log('kiosk_configs', _kioskConfigs);
    _isShowroomMode = _kioskConfigs['kv-showroom-mode'] || false;
    _isTimeoutDisabled = _kioskConfigs['kv-timeout-disabled'] || false;
    _isTabletMode = _kioskConfigs['tablet-mode'] || false;
    _subdomain = _kioskConfigs['subdomain'];
  });
}

const Config = {
  AmazonS3: {
    bucketName: __bucketName,
    root: function() {
      if(_kioskStandAlone) {
        return "file:///" + encodeURI(_parent.window.app.userDataPath.replace(/\\/g, "/")) + "/resources/" + __bucketName + "/";
      }
      //return "https://s3.amazonaws.com/" + __bucketName + "/";
      return `http://${__bucketName}.s3.amazonaws.com/`;
    }()
  },
  getScriptPath: function() {
    let scripts = document.getElementsByTagName("script");
    if(scripts && scripts.length) {
      for(let i = 0; i < scripts.length; i++) {
        let src = scripts[i].getAttribute('src');
        if(src && (src.includes("bundle.js") || src.includes("bundle.min.js"))) {
          return src.substring(0, src.lastIndexOf('/'));
        }
      }
    }
  },
  appRootNode: '.main-wrapper',
  layerSize: function () {
    return "1620x1080";

    //switch (_zoomLevel) {
    //  case 0: return "1620x1080";
    //  case 1: return "2419x1613";
    //  case 2: return "3218x2145";
    //  case 3: return "4018x2678";
    //  case 4: return "4817x3211";
    //  case 5: return ""; // it is actually 5616x3744, but we use the original image which is of this size and doesn't have the size suffix on S3
    //  default: throw "Unsupported zoom level: " + _zoomLevel;
    //}
  },

  maxZoom: 10,
  zoomIn: () => {
    if (_zoomLevel < (this.maxZoom - 1)) {
      _zoomLevel++;
    }
  },

  zoomOut: () => {
    if (_zoomLevel > 0) {
      _zoomLevel--;
    }
  },

  zoomLevel: () => _zoomLevel,

  /**
   * Returns an object of current view size based on zoom level
   */
  viewSize: () => {
    const w = 1620 + (1620 * _zoomLevel / 100.0) * 5;

    return {width: parseInt(w, 10), height: parseInt(w * 0.666667, 10)};
  },
  demoUserDomains: ['demo', 'cosentino'],
  isDemo: function () {
    if (_isDemo !== null) {
      return _isDemo;
    }

    _isDemo = document.kvConfig &&
      document.kvConfig.kioskMode &&
      this.demoUserDomains.some((d) => document.kvConfig.subdomain.toLowerCase() === d);
    return _isDemo;
  },
  kioskStandAlone: _kioskStandAlone,
  kvConfig: document.kvConfig,
  isKiosk: document.kvConfig.kioskMode,
  isShowroomMode: () => { return _isShowroomMode; },
  isTimeoutDisabled: () => { return _isTimeoutDisabled; },
  isTabletMode: () => { return _isTabletMode; },
  getSubdomain: () => { return _subdomain; },
  isMobile: () =>  _isMobile,
  getParent: () => _parent,
  isQTEmbedded: () => _isQTEmbedded,
  isTutorial: () => _isTutorial,
  isDevMode: () => _isDevMode,
  showAllVisualizerGroups: () => _showAllVisualizerGroups,
  isVisualizerManagement: () => _visMgmt,
  parent: _parent,
  /**
   * Is filled after the customer logins
   */
  userInfo: () => _userInfo,
  /**
   * Set user info
   * @param userInfo {object}
   */
  setUserInfo: (userInfo) => _userInfo = userInfo,

};

export default Config
